import { throttle } from 'throttle-debounce';
import { isMobile, addActiveLinkClass } from '../../utils';

const header = document.querySelector('[data-header]');
const burger = header.querySelector('[data-header-burger]');
const headerWrapper = document.querySelector('.header-wrapper');

// TODO: change color if menu not fixed
const dataColor = document.querySelector('[data-color]');
document.querySelector('.header-wrapper').style.backgroundColor =
  dataColor?.dataset?.color || '#38255B';

/**
 *  Toggle menu
 */
const toggleMenu = () => {
  if (!header && !burger) return;

  burger.addEventListener(
    'click',
    () => {
      if (header.classList.contains('open-menu')) {
        header.classList.remove('open-menu');
        document.getElementsByTagName('html')[0].style.overflowY = 'visible';
      } else {
        header.classList.add('open-menu');
        document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      }
    },
    false,
  );
};

/**
 *  Remove 'open-menu' class
 * @type {wrapper}
 */
const removeOpenMenuClass = throttle(200, () => {
  if (!isMobile() && header.classList.contains('open-menu')) {
    header.classList.remove('open-menu');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  toggleMenu();
  window.addEventListener('resize', removeOpenMenuClass, false);

  // Add active class
  addActiveLinkClass({
    anchorSelector: '.Header__nav__link',
  });
});

function FixedHeader() {
  const headerWrapper = document.querySelector('.header-wrapper');
  const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
  let offset = 20;

  if (!headerWrapper) return false;

  if (window.innerWidth <= 860) {
    offset = 0;
  }

  if (pageYOffset > offset) {
    headerWrapper.classList.add('fixed');
  } else {
    headerWrapper.classList.remove('fixed');
  }
}

document.addEventListener('scroll', () => {
  FixedHeader();
});

function hoverDesktopMenu() {
  const subMenus = document.querySelectorAll('.menu-item-has-children');
  const headerWrapper = document.querySelector('.header-wrapper');
  subMenus.forEach(item => {
    item.addEventListener('mouseover', () => {
      headerWrapper.style.backgroundColor = 'white';
      headerWrapper.classList.add('header-wrapper--open');
    });

    item.addEventListener('mouseout', () => {
      headerWrapper.style.backgroundColor = dataColor?.dataset.color || '#38255B';
      headerWrapper.classList.remove('header-wrapper--open');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const colorSelector = document.querySelector('[data-color]');
  if (colorSelector && colorSelector.dataset?.color) {
    header.style.backgroundColor = colorSelector || '#38255B';
  }

  if (window.matchMedia('(min-width: 1024px)').matches) {
    hoverDesktopMenu();
  }

  if (window.matchMedia('(max-width: 1024px)').matches) {
    [].slice.call(document.querySelectorAll('.menu-item-has-children')).forEach((submenu) => {
      submenu.addEventListener('click', () => {
        headerWrapper.classList.toggle('header-wrapper--open')
      });
    });
  }
});
